import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { c as n } from "../../../clsx-OuTLNxxd.js";
import { I as a } from "../../../icon-CCupal-M.js";
import "../icon/iconsList.js";
import { T as i } from "../../../text-CCLkQO4k.js";
const c = {
  "icon-text": "_icon-text_dclsq_29",
  "color-primary-50": "_color-primary-50_dclsq_34",
  "color-primary-100": "_color-primary-100_dclsq_37",
  "color-primary-200": "_color-primary-200_dclsq_40",
  "color-primary-300": "_color-primary-300_dclsq_43",
  "color-primary-400": "_color-primary-400_dclsq_46",
  "color-primary-500": "_color-primary-500_dclsq_49",
  "color-primary-600": "_color-primary-600_dclsq_52",
  "color-primary-700": "_color-primary-700_dclsq_55",
  "color-primary-800": "_color-primary-800_dclsq_58",
  "color-primary-900": "_color-primary-900_dclsq_61",
  "color-secondary-50": "_color-secondary-50_dclsq_64",
  "color-secondary-100": "_color-secondary-100_dclsq_67",
  "color-secondary-200": "_color-secondary-200_dclsq_70",
  "color-secondary-300": "_color-secondary-300_dclsq_73",
  "color-secondary-400": "_color-secondary-400_dclsq_76",
  "color-secondary-500": "_color-secondary-500_dclsq_79",
  "color-secondary-600": "_color-secondary-600_dclsq_82",
  "color-secondary-700": "_color-secondary-700_dclsq_85",
  "color-secondary-800": "_color-secondary-800_dclsq_88",
  "color-secondary-900": "_color-secondary-900_dclsq_91",
  "color-tertiary-50": "_color-tertiary-50_dclsq_94",
  "color-tertiary-100": "_color-tertiary-100_dclsq_97",
  "color-tertiary-200": "_color-tertiary-200_dclsq_100",
  "color-tertiary-300": "_color-tertiary-300_dclsq_103",
  "color-tertiary-400": "_color-tertiary-400_dclsq_106",
  "color-tertiary-500": "_color-tertiary-500_dclsq_109",
  "color-tertiary-600": "_color-tertiary-600_dclsq_112",
  "color-tertiary-700": "_color-tertiary-700_dclsq_115",
  "color-tertiary-800": "_color-tertiary-800_dclsq_118",
  "color-tertiary-900": "_color-tertiary-900_dclsq_121",
  "color-eco-green-50": "_color-eco-green-50_dclsq_124",
  "color-eco-green-100": "_color-eco-green-100_dclsq_127",
  "color-eco-green-200": "_color-eco-green-200_dclsq_130",
  "color-eco-green-300": "_color-eco-green-300_dclsq_133",
  "color-eco-green-400": "_color-eco-green-400_dclsq_136",
  "color-eco-green-500": "_color-eco-green-500_dclsq_139",
  "color-eco-green-600": "_color-eco-green-600_dclsq_142",
  "color-eco-green-700": "_color-eco-green-700_dclsq_145",
  "color-eco-green-800": "_color-eco-green-800_dclsq_148",
  "color-eco-green-900": "_color-eco-green-900_dclsq_151",
  "color-error-50": "_color-error-50_dclsq_154",
  "color-error-100": "_color-error-100_dclsq_157",
  "color-error-200": "_color-error-200_dclsq_160",
  "color-error-300": "_color-error-300_dclsq_163",
  "color-error-400": "_color-error-400_dclsq_166",
  "color-error-500": "_color-error-500_dclsq_169",
  "color-error-600": "_color-error-600_dclsq_172",
  "color-error-700": "_color-error-700_dclsq_175",
  "color-error-800": "_color-error-800_dclsq_178",
  "color-error-900": "_color-error-900_dclsq_181",
  "color-success-50": "_color-success-50_dclsq_184",
  "color-success-100": "_color-success-100_dclsq_187",
  "color-success-200": "_color-success-200_dclsq_190",
  "color-success-300": "_color-success-300_dclsq_193",
  "color-success-400": "_color-success-400_dclsq_196",
  "color-success-500": "_color-success-500_dclsq_199",
  "color-success-600": "_color-success-600_dclsq_202",
  "color-success-700": "_color-success-700_dclsq_205",
  "color-success-800": "_color-success-800_dclsq_208",
  "color-success-900": "_color-success-900_dclsq_211",
  "color-neutral-50": "_color-neutral-50_dclsq_214",
  "color-neutral-100": "_color-neutral-100_dclsq_217",
  "color-neutral-200": "_color-neutral-200_dclsq_220",
  "color-neutral-300": "_color-neutral-300_dclsq_223",
  "color-neutral-400": "_color-neutral-400_dclsq_226",
  "color-neutral-500": "_color-neutral-500_dclsq_229",
  "color-neutral-600": "_color-neutral-600_dclsq_232",
  "color-neutral-700": "_color-neutral-700_dclsq_235",
  "color-neutral-800": "_color-neutral-800_dclsq_238",
  "color-neutral-900": "_color-neutral-900_dclsq_241",
  "color-collection-50": "_color-collection-50_dclsq_244",
  "color-collection-100": "_color-collection-100_dclsq_247",
  "color-collection-200": "_color-collection-200_dclsq_250",
  "color-collection-300": "_color-collection-300_dclsq_253",
  "color-collection-400": "_color-collection-400_dclsq_256",
  "color-collection-500": "_color-collection-500_dclsq_259",
  "color-collection-600": "_color-collection-600_dclsq_262",
  "color-collection-700": "_color-collection-700_dclsq_265",
  "color-collection-800": "_color-collection-800_dclsq_268",
  "color-collection-900": "_color-collection-900_dclsq_271",
  "dialog-overlay-show": "_dialog-overlay-show_dclsq_1",
  "dialog-content-show": "_dialog-content-show_dclsq_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_dclsq_1"
};
function g({ text: r, icon: l, color: _ = "neutral-900", iconSize: e, textSize: s }) {
  const d = n(c["icon-text"], c[`color-${_}`]);
  return /* @__PURE__ */ t("div", { className: d, children: [
    /* @__PURE__ */ o(a, { name: l, color: "inherit", size: e }),
    /* @__PURE__ */ o(i, { color: "inherit", size: s, children: r })
  ] });
}
export {
  g as IconText
};
